/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  SearchUnmatchedDoorsQueryResponse,
  SearchUnmatchedDoorsQueryParams,
} from '../types/SearchUnmatchedDoors'

function getSearchUnmatchedDoorsUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/common/search/doors_unmatched/` as const,
  }
  return res
}

/**
 * @description Handle GET request for search.
 * This is the main entry point that orchestrates the search process.
 * @summary Search the tenant's custom (unmatched) doors
 * {@link /api/v1/common/search/doors_unmatched/}
 */
export async function searchUnmatchedDoors(
  params: SearchUnmatchedDoorsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    SearchUnmatchedDoorsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getSearchUnmatchedDoorsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
